import React from 'react';
import { PageLayout } from '../components/global/PageLayout';
import { PageIntro, Section } from '../components/ui/PageIntro';
import { GalleryGrid } from '../components/LowOnFuel/GalleryGrid';
import { CTABlock } from '../components/ui/CTABlock';
import { galleryImages } from '../data/gallery';
import { IMAGES } from '../data/images';
import { PAGE_META } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Gallery() {
  useDocumentMeta({
    ...PAGE_META.gallery,
    path: '/gallery'
  });
  return <PageLayout data-id="element-667" data-mp="2hm62v8y4v0rb">
      <PageIntro eyebrow="Gallery" title="Have a look round" intro="The door, the stone walls, the collection hung on them, the Fuel Stop hatch, the ice cream counter, the deck with the valley behind it, and a Friday night with the road full of bikes." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Gallery'
    }]} image={IMAGES.interiorMemorabilia.src} data-id="element-668" data-mp="2hlnx9lpkza6q" />

      <Section data-id="element-669" data-mp="1yqze4p4wo4l4">
        <GalleryGrid images={galleryImages} data-id="element-670" data-mp="2k96tdc1almh6" />
      </Section>

      <CTABlock data-id="element-671" data-mp="2k7ndhmjjtdfx" />
    </PageLayout>;
}